import {dataHooks} from '@wix/data-hooks'

export const experiencesListDataHooks = dataHooks<{
  root: {}
  experienceCard: {}
}>('experiences-list')
